import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../core';

import { EnumUsuarioEscopo } from '../enums/usuario-escopo.enum';
import { Usuario } from '../usuario';

@Injectable({
    providedIn: 'root'
})
export class TypeaheadUsuarioHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiTypeahead()}/usuario`
    }

    /** Pesquisa todos os usuários cadastrados para o typeahead */
    search(nome: string, situacoes: number[], perfil: number, limit: number, escopo?: EnumUsuarioEscopo): Observable<Usuario[]> {
        // Params
        let params = new HttpParams()
                            .append('nome', nome); // Nome

        // Situações
        if (situacoes && situacoes.length > 0) {
            situacoes.forEach(situacao => {
                params = params.append('situacao', situacao.toString());
            });
        }
        // Perfil
        if (perfil) {
            params = params.append('perfil', perfil.toString());
        }
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Escopo
        if (escopo) {
            params = params.append('escopo', escopo);
        }

        return this.customHttp.get<Usuario[]>(this.pathApi, {params});
    }
}
